import {useCallback, useState} from 'react';
import {Link, RadioGroup, Typography} from 'bonprix-design-system';
import {fillInitialClickedFilters} from '../../helper/filter-helper';
import {yieldToMain} from '../../ArticleOverviewHelper';

function Radio({filterOptions, identifier, trackingId, filterOptionChange, hideNumberOfItems}) {
    const initialValue = fillInitialClickedFilters(filterOptions)[0] || '';
    const [selectedValue, setSelectedValue] = useState(initialValue);

    const handleChange = useCallback((selectedRadioValue) => {
        setSelectedValue(selectedRadioValue);
        yieldToMain(() => filterOptionChange(identifier, trackingId, selectedRadioValue ? [selectedRadioValue] : []));
    }, [filterOptionChange, identifier, trackingId]);

    const handleClearSelection = useCallback(() => {
        handleChange('');
    }, [handleChange]);

    const renderLabel = (option) => {
        if (hideNumberOfItems) {
            return option.name;
        }
        return `${option.name} (${option.numberOfItems})`;
    };

    return (
        <>
            <RadioGroup
                name={`filter-${identifier}`}
                value={selectedValue}
                onChange={handleChange}
                componentName="radio-group"
                label=""
            >
                {filterOptions.map((option) => (
                    <RadioGroup.Item
                        key={option.value}
                        value={option.value}
                        label={renderLabel(option)}
                    />
                ))}
            </RadioGroup>
            {selectedValue && (
                <div className="py-[10px]">
                    <Link
                        component="button"
                        hideUnderline={true}
                        onClick={handleClearSelection}
                    >
                        <Typography>Auswahl aufheben</Typography>
                    </Link>
                </div>
            )}
        </>
    );
}

export default Radio;
